import React from 'react'
import ReactDOM from 'react-dom'
import SideBar from './layout/SideBar';
import store from "./storeWire";
import {Provider} from "react-redux";

ReactDOM.render(
    <Provider store={store}>
        <SideBar/>
    </Provider>
    , document.getElementById('sideBarApp'))
